export const division : any = (num : number, div : number) => {
  if (num === undefined || num === null || num === 0) {
    return undefined;
  }
  else if (div !== undefined && num !== null && num / div !== Infinity) {
    return num / div;
  }
  return undefined;
};

export const subtract : any = (a : number, b : number) : number => {
  if ((a === undefined || a === null) && (b === undefined || b === null)) {
    return undefined;
  }
  
  const A = a ?? 0;
  const B = b ?? 0;

  return A - B;
};

export const add : any = (a : number, b : number) : number => {
  if ((a === undefined || a === null) && (b === undefined || b === null)) {
    return undefined;
  }

  const A = a ?? 0;
  const B = b ?? 0;

  return A + B;
};